var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * TASK-084 — small reusable badge shown next to vocabulary records that are
 * currently `PENDING_REVIEW`. Returns null for `APPROVED` and null (legacy)
 * so callers can render unconditionally next to a record reference.
 *
 * Local and national review are different workflow phases, so their colours
 * remain distinct wherever this shared badge is used.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
var PHASE_STYLES = {
    PENDING_REVIEW: {
        backgroundColor: '#e3f2fd',
        border: '1px solid #90caf9',
        color: '#0d47a1',
    },
    PENDING_NATIONAL_REVIEW: {
        backgroundColor: '#f3e5f5',
        border: '1px solid #ce93d8',
        color: '#6a1b9a',
    },
    CHANGES_REQUESTED: {
        backgroundColor: '#fff3e0',
        border: '1px solid #ffb74d',
        color: '#9a4d00',
    },
};
export var ReviewBadge = function (_a) {
    var reviewStatus = _a.reviewStatus, messageId = _a.messageId, _b = _a.standalone, standalone = _b === void 0 ? false : _b;
    if (reviewStatus !== 'PENDING_REVIEW'
        && reviewStatus !== 'PENDING_NATIONAL_REVIEW'
        && reviewStatus !== 'CHANGES_REQUESTED') {
        return null;
    }
    return (React.createElement("span", { "data-test-review-badge": true, "data-review-stage": reviewStatus, style: __assign(__assign({}, PHASE_STYLES[reviewStatus]), { padding: '2px 6px', marginLeft: standalone ? 0 : '6px', fontSize: '0.85em', borderRadius: '4px', fontWeight: 500 }) },
        React.createElement(FormattedMessage, { id: messageId !== null && messageId !== void 0 ? messageId : (reviewStatus === 'PENDING_NATIONAL_REVIEW'
                ? 'ui-czna-authorities.review.badge.pendingNational'
                : reviewStatus === 'CHANGES_REQUESTED'
                    ? 'ui-czna-authorities.review.badge.changesRequested'
                    : 'ui-czna-authorities.review.badge.pending') })));
};
ReviewBadge.propTypes = {
    reviewStatus: PropTypes.oneOf([
        'PENDING_REVIEW', 'PENDING_NATIONAL_REVIEW', 'CHANGES_REQUESTED', 'APPROVED', null,
    ]),
    messageId: PropTypes.string,
    standalone: PropTypes.bool,
};
export default ReviewBadge;
